import { inject } from 'helpers/mobx'
import { useRouter } from 'helpers/navigation'
import React, { FC } from 'react'
import RoundButton from 'uiComponents/atoms/Buttons/RoundButton'
import { Icon, IconSize } from 'uiComponents/atoms/Icon/Icon'
import { IconName } from 'uiComponents/atoms/Icon/IconName'

const isExternalReferrer = (urlManagerStoreHistory: string[]): boolean => {
  if (typeof window === 'undefined' || urlManagerStoreHistory.length === 1) {
    return true
  }
  return window.history.length > 1 && urlManagerStoreHistory.length === 1
}

interface IBackButtonProps {
  externalReferer: boolean
  linkTo: string
}

const BackButton: FC<IBackButtonProps> = ({ externalReferer, linkTo }) => {
  const { navigateClient } = useRouter()
  const onBackButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    const isNewTab = window.history.length === 1
    if (!linkTo || isNewTab || externalReferer) {
      navigateClient(linkTo)(event)
      return
    }
    event.preventDefault()
    window.history.back()
  }

  return (
    <a data-testid="BackButton" href={linkTo} onClick={onBackButtonClick}>
      <RoundButton backgroundColor={'secondary'} data-testid="RoundBackButton">
        <Icon
          size={IconSize.XS}
          asset={IconName.IcChevronLeft}
          data-testid="BackButtonArrow"
        />
      </RoundButton>
    </a>
  )
}

export default inject(
  store => {
    const breadCrumbs = store.breadcrumbsStore.items
    const linkTo = (breadCrumbs[breadCrumbs.length - 1] || { url: '/' }).url

    return {
      externalReferer: isExternalReferrer(store.urlManagerStore.history),
      linkTo,
    }
  },
  {
    observe: true,
  },
)((props: IBackButtonProps) => <BackButton {...props} />)
